// TODO: add test to make sure all routes are implemented in RoutesStore

/* eslint typescript-sort-keys/string-enum: "error" */
export enum VignetteRoutes {
  Briefcase = "Briefcase",
  BriefcaseFolder = "BriefcaseFolder",
  Contact = "Contact",
  Debug = "Debug",
  Faq = "Faq",
  FeaturedProfiles = "FeaturedProfiles",
  Home = "Home",
  Loading = "Loading",
  LoginRedirect = "LoginRedirect",
  MyAccount = "MyAccount",
  MyAccount_AssignedUsers = "AssignedUsers",
  NotFound = "NotFound",
  PayWall = "PayWall",
  Profile = "Profile",
  ProfileLanding = "ProfileLanding",
  Search = "Search",
  SignUp = "SignUp",
  SignUpRegistration = "SignUpRegistration",
  SignUp_Success = "Success",
  SignUp_ThankYou = "ThankYou",
  Welcome = "Welcome",
}
